import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { debounceTime, distinctUntilChanged } from 'rxjs';
import { APIServiceService } from 'src/app/api/apiservice.service';
import { Address } from 'src/app/models/address.model';
import { ModalService } from 'src/app/services/modal.service';
import { SharedUIModuleModule } from 'src/app/shared/shared-uimodule/shared-uimodule.module';
import { environment } from 'src/environments/environment';
import { getCustomerInitials } from 'src/utils/display';


@Component({
  selector: 'ubc-new-address-form',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule],
  templateUrl: './new-address-form.component.html',
  styleUrl: './new-address-form.component.scss'
})
export class NewAddressFormComponent {
  listOpen = false
  searchControl: FormControl = new FormControl('');

  options: Address[] = []
  selectedAddress?: Address

  addressForm: FormGroup

  w3w_api_key = environment.what3WordsApiKey
  google_api_key = environment.googleApiKey

  buttonTitle = "Create Address"

  constructor(
    private apiService: APIServiceService,
    private modalService: ModalService
  ){
    
  }

  ngOnInit(){
    
    // this.selectedCustomer = this.options[3]

    if(this.modalService.address){
      console.log("Modal service address ", this.modalService.address)
      this.selectedAddress = this.modalService.address
      this.buttonTitle = "Edit Address"
      this.initForm()
    }
    

    this.searchControl.valueChanges.pipe(
      debounceTime(300),
      distinctUntilChanged()
    ).subscribe(term => {
      this.searchForAddress(term)
      .then(results => {
        this.options = results
        console.log(this.options)
      })
    })
  }

  initForm(){
    if(this.addressForm){
      this.addressForm.reset()
    }
    this.addressForm = new FormGroup({
      line1: new FormControl((this.selectedAddress) ? this.selectedAddress.line1 : '', Validators.required),
      line2: new FormControl((this.selectedAddress) ? this.selectedAddress.line2 : ''),
      town: new FormControl((this.selectedAddress) ? this.selectedAddress.town : ''),
      city: new FormControl((this.selectedAddress) ? this.selectedAddress.city : ''),
      postcode: new FormControl((this.selectedAddress) ? this.selectedAddress.postcode : ''),
      country: new FormControl((this.selectedAddress && this.selectedAddress.country) ? this.selectedAddress.country : 'United Kingdom', Validators.required),
      w3w: new FormControl((this.selectedAddress) ? this.selectedAddress.w3w : ''),
      notes: new FormControl((this.selectedAddress) ? this.selectedAddress.notes : '')
    })
  }

  toggleList(){
    this.listOpen = !this.listOpen
  }

  async searchForAddress(term: string): Promise<Address[]>{

    if(term === ""){
      return []
    }

    try {
      const response = await this.apiService.addresses.geoLookup(term)
      if(!response.success || !response.data || response.data.results.length === 0){
        return []
      }

      this.listOpen = true

      return response.data.results.filter((result) => { 
        const isApproximate = result.geometry.location_type === "APPROXIMATE"
        const isPostcode = result.types.includes("postal_code")
        return ( !isApproximate || isPostcode )
      
      }).map((result) => {
        return Address.fromGeocodeResult(result)
      })
    } catch(e){
      console.log(e)
      return []
    }

  }

  addressPicked(address: Address){
    this.selectedAddress = address
    this.initForm()
  }

  async formSubmitted(){    


    const addressData = this.addressForm.value
    addressData.customerId = this.modalService.customer!.id
    if(this.selectedAddress && this.selectedAddress.id){
      addressData.id = this.selectedAddress.id
    }
    try {

      
      const createdResponse = await this.apiService.addresses.createOrUpdate(addressData)
      
      if(createdResponse.success){
        const newAddress = createdResponse.data
        this.addressForm.reset()
        this.modalService.dismiss()
        this.modalService.broadcastEvent({ type: 'CUSTOMER', action: 'addresses_updated', newAddress })

      }
    } catch(e){
      console.log("Error saving address")
    }
  }

  cancelClicked(){
    this.selectedAddress = undefined
  }

  createNewAddressClicked(){
    this.selectedAddress = new Address()
    this.initForm()
  }

 

  getInitials(address: Address){
    return getCustomerInitials(null)
  }

  stringToHexColor(str: string): string {
    return this.stringToHexColor(str)
  }
}
